import { motion, useReducedMotion } from "framer-motion";
import { springTransition } from "@/lib/motionVariants";

export default function HoverLift({
    children,
    className,
    y = -6,
    scale = 1.02,
}) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            whileHover={{ y, scale }}
            whileTap={{ scale: 0.98, y: 0 }}
            transition={springTransition}
        >
            {children}
        </motion.div>
    );
}
